(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["popup-email"] && !Shopify.designMode) return;
  try {
    
(function () {
  var KEY = 'rcEmailPopup:v1';
  var lastFocus;

  function root() { return document.getElementById('rcEmailPopup'); }
  function mark(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
  function suppressed(days) {
    try {
      var v = localStorage.getItem(KEY);
      if (!v) return false;
      if (v === 'converted') return true;
      var ts = parseInt(v, 10);
      if (isNaN(ts)) return false;
      return (Date.now() - ts) < days * 86400000;
    } catch (e) { return false; }
  }
  function openPopup(el, isSuccess) {
    if (!el || el.classList.contains('open')) return;
    lastFocus = document.activeElement;
    el.classList.add('open');
    el.setAttribute('aria-hidden', 'false');
    // Reserve the scrollbar width so locking scroll doesn't shift the page.
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
    if (!isSuccess) mark(String(Date.now()));
    var f = el.querySelector('input[type="email"]') || el.querySelector('[data-popup-close]');
    if (f) { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }
  }
  function closePopup(el) {
    if (!el) return;
    el.classList.remove('open');
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }

  function bindDismiss(el) {
    el.addEventListener('click', function (e) {
      if (e.target === el || (e.target.closest && e.target.closest('[data-popup-close]'))) closePopup(el);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && el.classList.contains('open')) closePopup(el);
    });
  }

  function init() {
    var el = root();
    if (!el) return;
    bindDismiss(el);

    // Theme editor: show the popup when its section is selected or (re)loaded - e.g. right after
    // you tick "Enable popup" - so you can see and style it. Ignore other sections' events.
    if (window.Shopify && window.Shopify.designMode) {
      var isOurs = function (e) { var r = root(); return r && e.detail && e.detail.sectionId === r.dataset.sectionId; };
      document.addEventListener('shopify:section:select', function (e) { if (isOurs(e)) openPopup(root(), false); });
      document.addEventListener('shopify:section:load', function (e) { if (isOurs(e)) openPopup(root(), false); });
      document.addEventListener('shopify:section:deselect', function (e) { if (isOurs(e)) closePopup(root()); });
      openPopup(el, false); // show immediately if already present on load
      return;
    }

    // Live storefront
    if (el.querySelector('[data-popup-success]')) {
      // Shopify reloaded the page after a successful signup: show thank-you, never nag again.
      mark('converted');
      openPopup(el, true);
      return;
    }

    var days = parseInt(el.dataset.frequency, 10); if (isNaN(days)) days = 30;
    if (suppressed(days)) return;

    var delay = (parseInt(el.dataset.delay, 10) || 6) * 1000;
    var exitOn = el.dataset.exit === 'true';
    var armed = true;
    var timer = setTimeout(function () { if (armed) { armed = false; openPopup(root(), false); } }, delay);
    if (exitOn) {
      document.addEventListener('mouseout', function onExit(e) {
        if (e.clientY <= 0 && !e.relatedTarget && armed) {
          armed = false; clearTimeout(timer); openPopup(root(), false);
          document.removeEventListener('mouseout', onExit);
        }
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

  } catch(e) { console.error(e); }
})();
})();
